import { BadgeCheckboxes } from './BadgeCheckboxes.component';
import { BadgeCheckboxesForm } from './BadgeCheckboxesForm.component';

// eslint-disable-next-line import/prefer-default-export
export { BadgeCheckboxes, BadgeCheckboxesForm };
